// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AHU1o","index":"styles_index__26_DM"};